export default "__VITE_PUBLIC_ASSET__d68e6d21__"